<div >
  <nav class="navbar navbar-expand-lg navbar-light   topbar mb-4 static-top shadow d-md-block">
    <ul class="navbar-nav me-auto mb-2 mb-lg-00" style="width: 100%">
      <li class="nav-item " *ngIf="verMenuDirectorio()">
        <a class="nav-link active" aria-current="page" (click)="goDirectorio()">
        <span class="mr-2 d-lg-inline " style="color: white;">Directorio</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuUsuarios()">
        <a class="nav-link active" aria-current="page" (click)="goUsuarios()">
        <span class="mr-2 d-lg-inline " style="color: white;">Usuarios</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuParametricas()">
        <a class="nav-link active" aria-current="page" (click)="goParametricas()">
        <span class="mr-2 d-lg-inline " style="color: white;">Paramétricas Variables</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuCalendario()">
        <a class="nav-link active" aria-current="page" (click)="goCalendario()">
        <span class="mr-2 d-lg-inline " style="color: white;">Calendario</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuAnalisis()">
        <a class="nav-link active" aria-current="page" (click)="irAnalisis()">
        <span class="mr-2 d-lg-inline " style="color: white;">Analisis</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuAdmininfo()">
        <a class="nav-link active" aria-current="page" (click)="irAdministracionInfo()">
        <span class="mr-2 d-lg-inline " style="color: white;">Administración Información</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuOperativo()">
        <a class="nav-link active" aria-current="page" (click)="irOperativo()">
        <span class="mr-2 d-lg-inline " style="color: white;">Control Operativo</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuIndicadores()">
        <a class="nav-link active" aria-current="page" (click)="irIndicadores()">
        <span class="mr-2 d-lg-inline " style="color: white;">Indicadores</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuCuadrossalida()">
        <a class="nav-link active" aria-current="page" (click)="irCuadrosSalida()">
        <span class="mr-2 d-lg-inline " style="color: white;">Cuadros de Salida</span></a>
      </li>
      <!--Pestañas Fuente-->
      <li class="nav-item " *ngIf="verMenuDatosBasicos()">
        <a class="nav-link active" aria-current="page" (click)="goCaratula()">
        <span class="mr-2 d-lg-inline " style="color: white;">Datos Básicos</span></a>
      </li>
      <!--li class="nav-item " *ngIf="tipoUsuario=='Supersolidaria'">
        <a class="nav-link active" aria-current="page" (click)="goCaratula()">
        <span class="mr-2 d-lg-inline " style="color: white;">Entidades</span></a>
      </li-->
      <li class="nav-item " *ngIf="verMenuCargueMasivo()">
        <a class="nav-link active" aria-current="page" (click)="goCargueMasivo()">
        <span class="mr-2 d-lg-inline " style="color: white;">Cargue Masivo</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuNovedades()">
        <a class="nav-link active" aria-current="page" (click)="goNovedades()">
        <span class="mr-2 d-lg-inline " style="color: white;">Novedades</span></a>
      </li>
      <li class="nav-item " *ngIf="verMenuConsultarReportes()">
        <a class="nav-link" aria-current="page" (click)="goConsultaReporte()">
        <span class="mr-2 d-lg-inline " style="color: white;">Consulta Reportes</span></a>
      </li>
    </ul>
  </nav>
</div>


